import api from './api';

export const getCurrentUserId = async () => {
  try {
    const response = await api.get('/user/id');
    return response.data.id;
  } catch (error) {
    console.error('Failed to get current user ID:', error);
    return null;
  }
};

/**
 * トークンを持っているか。**同期。**
 *
 * 判定材料は localStorage だけなので待つ必要が無い。
 * `isAuthenticated()` を await すると、レンダー時に結果を使えず
 * 「一度ページを描いてから effect でリダイレクト」になる。
 * 未ログインでも中身が一瞬見えてクエリまで飛ぶので、レンダー内で判定したい場所は
 * こちらを使うこと。
 */
export const hasAuthToken = (): boolean => {
  try {
    return !!localStorage.getItem('token');
  } catch (error) {
    return false;
  }
};

/** @deprecated レンダー内で判定できる `hasAuthToken()` を使うこと */
export const isAuthenticated = async () => hasAuthToken();

export const isSuperuser = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
    
    const response = await api.get('/user/is-superuser/');
    return response.data.is_superuser;
  } catch (error) {
    console.error('Failed to check superuser status:', error);
    return false;
  }
};
